"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_RATE_PHOTOS = exports.MAX_RATES_BY_TICKETING_IN_DB_LIMIT = exports.MAX_RATES_LIMIT = void 0;
/**
 * This is the maximum number of rates that can be created in a ticketing form.
 * It is used to limit the number of rates that can be created in a ticketing form.
 */
exports.MAX_RATES_LIMIT = 200;
/**
 * This is the maximum number of rates that created in a ticketing form in our database since 2025/01/01.
 * Since 2025/04/23, we have a limit of 200 rates per ticketing form.
 */
exports.MAX_RATES_BY_TICKETING_IN_DB_LIMIT = 400;
exports.MAX_RATE_PHOTOS = 20;
